/** Namespace `intake` (Admin-Panel + Liste) — befüllt während der Migration. */
export const intake = {
  de: {
    intake: {
      list: {
        eyebrow: 'Patientenakte',
        title: 'Erhebungsbögen',
        description: 'Übersicht aller eingereichten Patientenbögen mit Versand-Status und PDF-Archiv',
        countOf: 'von',
        errorLoad: 'Bögen konnten nicht geladen werden',
        statTotal: 'Bögen gesamt',
        statSent: 'Mail versendet',
        statFailed: 'Mail fehlgeschlagen',
        statPending: 'Mail ausstehend',
        searchLabel: 'Suche (Name, E-Mail, Ort)',
        searchPlaceholder: 'z. B. Müller oder Palma',
        formStatus: 'Bogen-Status',
        formStatusAll: 'Alle',
        formStatusSubmitted: 'Ausgefüllt',
        formStatusPending: 'Wartet auf Patient',
        mailStatus: 'Mail-Status',
        mailStatusAll: 'Alle',
        language: 'Sprache',
        languageAll: 'Alle',
        submittedFrom: 'Eingereicht ab',
        submittedTo: 'Eingereicht bis',
        bulkResendConfirm: 'Mail-Versand für {{count}} fehlgeschlagene Bögen erneut versuchen?',
        bulkSending: 'Sende …',
        bulkResendAll: 'Alle fehlgeschlagenen erneut senden ({{count}})',
        bulkResult: 'Bulk-Resend: {{ok}} erfolgreich, {{fail}} weiterhin fehlgeschlagen',
        resetFilters: 'Filter zurücksetzen',
        loading: 'Lade…',
        emptyNoHitsTitle: 'Keine Treffer',
        emptyNoFormsTitle: 'Noch keine Bögen',
        emptyNoHitsDescription: 'Keine Erhebungsbögen entsprechen den aktuellen Filtern.',
        emptyNoFormsDescription: 'Sobald Patienten den Bogen ausfüllen, erscheinen sie hier.',
        colPatient: 'Patient',
        colAppointment: 'Termin',
        colSubmitted: 'Eingereicht',
        colLanguage: 'Sprache',
        colMailStatus: 'Mail-Status',
        colActions: 'Aktionen',
        downloadPdf: 'PDF herunterladen',
        resendMail: 'Mail erneut senden',
        toAppointment: 'Zum Termin',
        send: 'Senden',
        appointment: 'Termin',
        submittedLabel: 'Eingereicht',
        resend: 'Erneut senden',
        errorPdf: 'PDF konnte nicht geladen werden',
        mailSentTo: 'Mail an {{to}} versendet',
        sendFailed: 'Versand fehlgeschlagen: {{error}}',
        errorUnknown: 'Unbekannt',
        errorResend: 'Resend fehlgeschlagen',
        mailStatusSent: 'Versendet',
        mailStatusFailed: 'Fehlgeschlagen',
        mailStatusPending: 'Ausstehend',
        langDe: 'Deutsch',
        langEn: 'English',
        langEs: 'Español',
        langRu: 'Русский',
      },
      panel: {
        errorLoad: 'Fehler beim Laden',
        loading: 'Lädt …',
        noData: 'Keine Daten',
        attempts: 'Versuche: {{count}} · zuletzt {{date}}',
        mailFailedHeading: 'E-Mail an {{to}} konnte nicht versendet werden:',
        patientLink: 'Patient-Link',
        copied: 'Kopiert!',
        copyLink: 'Link kopieren',
        linkCopiedToast: 'Link in die Zwischenablage kopiert',
        copyFailedToast: 'Konnte Link nicht kopieren',
        openPdf: 'PDF öffnen',
        downloadPdf: 'PDF herunterladen',
        sending: 'Sende …',
        resend: 'Erneut senden',
        resendMail: 'E-Mail erneut senden',
        qrCode: 'QR-Code',
        sendLinkTitle: 'Link an Patient senden',
        sendLinkHint: 'Der Patient erhält eine freundliche E-Mail mit Link und QR-Code — kann den Bogen direkt auf dem Handy ausfüllen.',
        sendToPatient: 'An Patient senden',
        lastSentTo: 'Zuletzt versendet an',
        invalidEmail: 'Bitte eine gültige E-Mail-Adresse eingeben',
        invitationSent: 'Einladung an {{to}} versendet',
        invitationFailed: 'Versand fehlgeschlagen: {{error}}',
        invitationError: 'Versand fehlgeschlagen',
        errorUnknown: 'Unbekannt',
        mailResentTo: 'E-Mail an {{to}} versendet',
        mailResendFailed: 'Mail fehlgeschlagen: {{error}}',
        errorResend: 'Resend fehlgeschlagen',
        downloadFailed: 'PDF-Download fehlgeschlagen',
        openPdfFailed: 'PDF konnte nicht geöffnet werden',
        notSubmittedHint: 'Der Patient hat den Bogen noch nicht ausgefüllt. Schicken Sie den Link per E-Mail oder zeigen Sie den QR-Code in der Praxis.',
        mailFallbackTo: 'info@seadent.es',
        mailSent: 'E-Mail versendet',
        mailFailed: 'E-Mail fehlgeschlagen',
        mailPending: 'E-Mail ausstehend',
        formFilled: 'Bogen ausgefüllt',
        formWaiting: 'Wartet auf Patient',
        yes: 'Ja',
        no: 'Nein',
        unsure: 'Unsicher',
        answersTitle: 'Antworten des Patienten',
        showOnlyNotable: 'Nur auffällige Antworten zeigen',
        showAll: 'Alle Antworten zeigen',
        submitted: 'Eingereicht',
        signature: 'Unterschrift',
        language: 'Sprache',
        masterData: 'Stammdaten',
        cardiovascular: 'Herz/Kreislauf',
        otherDiseases: 'Weitere Erkrankungen',
        otherDiseasesText: 'Sonstige Erkrankungen: ',
        infectiousDiseases: 'Infektiöse Erkrankungen',
        otherInfectiousText: 'Andere infektiös: ',
        allergies: 'Allergien',
        metalsAllergyText: 'Metall-Allergie: ',
        pregnant: 'Schwanger:',
        pregnantMonth: 'Monat {{month}}',
        majorSurgery: 'Große OP:',
        dentalXray: 'Zahn-Röntgen:',
        medications: 'Medikamente',
        since: 'seit {{since}}',
        specialTherapies: 'Spezielle Therapien',
        signatureAlt: 'Unterschrift',
        personal: {
          name: 'Name',
          street: 'Straße',
          postal_code: 'PLZ',
          city: 'Ort',
          country: 'Land',
          email: 'E-Mail',
          date_of_birth: 'Geburtsdatum',
          place_of_birth: 'Geburtsort',
          phone_private: 'Tel. privat',
          phone_work: 'Tel. dienstlich',
          occupation: 'Beruf',
          nie: 'N.I.E.',
          doctor_name: 'Hausarzt',
          doctor_address: 'Anschrift',
          doctor_phone: 'Telefon',
        },
        flags: {
          high_blood_pressure: 'Hoher Blutdruck',
          low_blood_pressure: 'Niedriger Blutdruck',
          heart_valve_disease: 'Herzklappenfehler',
          heart_valve_replacement: 'Herzklappenersatz',
          pacemaker: 'Herzschrittmacher',
          endocarditis: 'Endokarditis',
          heart_surgery: 'Herzoperation',
          epilepsy: 'Epilepsie',
          asthma: 'Asthma / Lunge',
          blood_clotting: 'Blutgerinnung',
          diabetes: 'Diabetes',
          drug_dependency: 'Drogen',
          nerve_disease: 'Nervenerkrankung',
          kidney_disease: 'Nieren',
          fainting_spells: 'Ohnmachtsanfälle',
          osteoporosis: 'Osteoporose',
          severe_neutropenia: 'Neutropenie',
          cystic_fibrosis: 'Mukoviszidose',
          organ_transplant: 'Organtransplantat',
          stem_cell_transplant: 'Stammzelltransplantat',
          smoker: 'Raucher',
          rheumatism: 'Rheuma',
          thyroid_disease: 'Schilddrüse',
          other_diseases: 'Sonstige',
          hiv: 'HIV/AIDS',
          hepatitis: 'Hepatitis',
          tuberculosis: 'Tuberkulose',
          other_infectious: 'Sonstige infektiös',
          local_anesthesia: 'Lokalanästhesie',
          antibiotics: 'Antibiotika',
          pain_medication: 'Schmerzmittel',
          bisphosphonates: 'Bisphosphonate',
          chemotherapy: 'Chemotherapie',
          radiation_therapy: 'Strahlentherapie',
          steroids: 'Steroide',
        },
      },
    },
  },
  es: {
    intake: {
      list: {
        eyebrow: 'Historia clínica',
        title: 'Cuestionarios',
        description: 'Vista general de todos los cuestionarios enviados con estado de envío y archivo PDF',
        countOf: 'de',
        errorLoad: 'No se pudieron cargar los cuestionarios',
        statTotal: 'Cuestionarios en total',
        statSent: 'Correo enviado',
        statFailed: 'Correo fallido',
        statPending: 'Correo pendiente',
        searchLabel: 'Búsqueda (nombre, correo, lugar)',
        searchPlaceholder: 'p. ej., Müller o Palma',
        formStatus: 'Estado del cuestionario',
        formStatusAll: 'Todos',
        formStatusSubmitted: 'Completado',
        formStatusPending: 'En espera del paciente',
        mailStatus: 'Estado del correo',
        mailStatusAll: 'Todos',
        language: 'Idioma',
        languageAll: 'Todos',
        submittedFrom: 'Enviado desde',
        submittedTo: 'Enviado hasta',
        bulkResendConfirm: '¿Reintentar el envío de correo para {{count}} cuestionarios fallidos?',
        bulkSending: 'Enviando …',
        bulkResendAll: 'Reenviar todos los fallidos ({{count}})',
        bulkResult: 'Reenvío masivo: {{ok}} correctos, {{fail}} aún fallidos',
        resetFilters: 'Restablecer filtros',
        loading: 'Cargando…',
        emptyNoHitsTitle: 'Sin resultados',
        emptyNoFormsTitle: 'Aún no hay cuestionarios',
        emptyNoHitsDescription: 'Ningún cuestionario coincide con los filtros actuales.',
        emptyNoFormsDescription: 'En cuanto los pacientes completen el cuestionario, aparecerán aquí.',
        colPatient: 'Paciente',
        colAppointment: 'Cita',
        colSubmitted: 'Enviado',
        colLanguage: 'Idioma',
        colMailStatus: 'Estado del correo',
        colActions: 'Acciones',
        downloadPdf: 'Descargar PDF',
        resendMail: 'Reenviar correo',
        toAppointment: 'A la cita',
        send: 'Enviar',
        appointment: 'Cita',
        submittedLabel: 'Enviado',
        resend: 'Reenviar',
        errorPdf: 'No se pudo cargar el PDF',
        mailSentTo: 'Correo enviado a {{to}}',
        sendFailed: 'Error en el envío: {{error}}',
        errorUnknown: 'Desconocido',
        errorResend: 'Error al reenviar',
        mailStatusSent: 'Enviado',
        mailStatusFailed: 'Fallido',
        mailStatusPending: 'Pendiente',
        langDe: 'Alemán',
        langEn: 'Inglés',
        langEs: 'Español',
        langRu: 'Ruso',
      },
      panel: {
        errorLoad: 'Error al cargar',
        loading: 'Cargando …',
        noData: 'Sin datos',
        attempts: 'Intentos: {{count}} · último {{date}}',
        mailFailedHeading: 'No se pudo enviar el correo a {{to}}:',
        patientLink: 'Enlace del paciente',
        copied: '¡Copiado!',
        copyLink: 'Copiar enlace',
        linkCopiedToast: 'Enlace copiado al portapapeles',
        copyFailedToast: 'No se pudo copiar el enlace',
        openPdf: 'Abrir PDF',
        downloadPdf: 'Descargar PDF',
        sending: 'Enviando …',
        resend: 'Reenviar',
        resendMail: 'Reenviar correo',
        qrCode: 'Código QR',
        sendLinkTitle: 'Enviar enlace al paciente',
        sendLinkHint: 'El paciente recibe un correo amable con enlace y código QR — puede rellenar el cuestionario directamente en el móvil.',
        sendToPatient: 'Enviar al paciente',
        lastSentTo: 'Último envío a',
        invalidEmail: 'Introduzca una dirección de correo electrónico válida',
        invitationSent: 'Invitación enviada a {{to}}',
        invitationFailed: 'Error en el envío: {{error}}',
        invitationError: 'Error en el envío',
        errorUnknown: 'Desconocido',
        mailResentTo: 'Correo enviado a {{to}}',
        mailResendFailed: 'Correo fallido: {{error}}',
        errorResend: 'Error al reenviar',
        downloadFailed: 'Error al descargar el PDF',
        openPdfFailed: 'No se pudo abrir el PDF',
        notSubmittedHint: 'El paciente aún no ha rellenado el cuestionario. Envíe el enlace por correo o muestre el código QR en la clínica.',
        mailFallbackTo: 'info@seadent.es',
        mailSent: 'Correo enviado',
        mailFailed: 'Correo fallido',
        mailPending: 'Correo pendiente',
        formFilled: 'Cuestionario completado',
        formWaiting: 'En espera del paciente',
        yes: 'Sí',
        no: 'No',
        unsure: 'No estoy seguro',
        answersTitle: 'Respuestas del paciente',
        showOnlyNotable: 'Mostrar solo respuestas relevantes',
        showAll: 'Mostrar todas las respuestas',
        submitted: 'Enviado',
        signature: 'Firma',
        language: 'Idioma',
        masterData: 'Datos maestros',
        cardiovascular: 'Cardiovascular',
        otherDiseases: 'Otras enfermedades',
        otherDiseasesText: 'Otras enfermedades: ',
        infectiousDiseases: 'Enfermedades infecciosas',
        otherInfectiousText: 'Otras infecciosas: ',
        allergies: 'Alergias',
        metalsAllergyText: 'Alergia a metales: ',
        pregnant: 'Embarazada:',
        pregnantMonth: 'Mes {{month}}',
        majorSurgery: 'Cirugía mayor:',
        dentalXray: 'Radiografía dental:',
        medications: 'Medicamentos',
        since: 'desde {{since}}',
        specialTherapies: 'Terapias especiales',
        signatureAlt: 'Firma',
        personal: {
          name: 'Nombre',
          street: 'Calle',
          postal_code: 'C.P.',
          city: 'Localidad',
          country: 'País',
          email: 'Correo electrónico',
          date_of_birth: 'Fecha de nacimiento',
          place_of_birth: 'Lugar de nacimiento',
          phone_private: 'Tel. particular',
          phone_work: 'Tel. trabajo',
          occupation: 'Profesión',
          nie: 'N.I.E.',
          doctor_name: 'Médico de cabecera',
          doctor_address: 'Dirección',
          doctor_phone: 'Teléfono',
        },
        flags: {
          high_blood_pressure: 'Presión arterial alta',
          low_blood_pressure: 'Presión arterial baja',
          heart_valve_disease: 'Valvulopatía cardíaca',
          heart_valve_replacement: 'Prótesis valvular cardíaca',
          pacemaker: 'Marcapasos',
          endocarditis: 'Endocarditis',
          heart_surgery: 'Cirugía cardíaca',
          epilepsy: 'Epilepsia',
          asthma: 'Asma / pulmón',
          blood_clotting: 'Coagulación sanguínea',
          diabetes: 'Diabetes',
          drug_dependency: 'Drogas',
          nerve_disease: 'Enfermedad neurológica',
          kidney_disease: 'Riñones',
          fainting_spells: 'Desmayos',
          osteoporosis: 'Osteoporosis',
          severe_neutropenia: 'Neutropenia',
          cystic_fibrosis: 'Fibrosis quística',
          organ_transplant: 'Trasplante de órganos',
          stem_cell_transplant: 'Trasplante de células madre',
          smoker: 'Fumador',
          rheumatism: 'Reumatismo',
          thyroid_disease: 'Tiroides',
          other_diseases: 'Otras',
          hiv: 'VIH/SIDA',
          hepatitis: 'Hepatitis',
          tuberculosis: 'Tuberculosis',
          other_infectious: 'Otras infecciosas',
          local_anesthesia: 'Anestesia local',
          antibiotics: 'Antibióticos',
          pain_medication: 'Analgésicos',
          bisphosphonates: 'Bifosfonatos',
          chemotherapy: 'Quimioterapia',
          radiation_therapy: 'Radioterapia',
          steroids: 'Esteroides',
        },
      },
    },
  },
};
